import type { SocialPlatform, SocialPresence } from '../../../../api/venues';

import { platformCells } from './social-platform-cells';

export const SOCIAL_COLUMNS = '80px minmax(0,1.2fr) 64px 96px minmax(0,1fr)';

const smallCaps = {
  fontSize: 9.5,
  fontWeight: 700,
  letterSpacing: '.05em',
  textTransform: 'uppercase',
  color: 'var(--nb-subtle)',
} as const;

interface SocialPlatformRowProps {
  platform: SocialPlatform;
  presence: SocialPresence | undefined;
  /** Stack the row for a narrow screen. */
  compact: boolean;
  onVerify?: (platform: SocialPlatform) => void;
  busy: boolean;
}

/** One platform in the read view: handle, audience, cadence and last verified. */
export function SocialPlatformRow({
  platform,
  presence,
  compact,
  onVerify,
  busy,
}: SocialPlatformRowProps) {
  const cells = platformCells({ platform, presence, onVerify, busy, alignEnd: compact });

  if (compact) {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr auto',
          gap: '4px 10px',
          padding: '10px 0',
          borderTop: '1px solid var(--nb-border)',
        }}
      >
        {cells.name}
        {cells.verify}
        <div style={{ gridColumn: '1 / -1', minWidth: 0 }}>{cells.handle}</div>
        <div
          style={{
            gridColumn: '1 / -1',
            display: 'flex',
            gap: 14,
            fontSize: 12,
            color: 'var(--nb-ink-2)',
          }}
        >
          <span>
            <span style={smallCaps}>Audience </span>
            {cells.audience}
          </span>
          <span>
            <span style={smallCaps}>Cadence </span>
            {cells.cadence}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: SOCIAL_COLUMNS,
        gap: 10,
        alignItems: 'center',
        padding: '9px 0',
        borderTop: '1px solid var(--nb-border)',
        fontSize: 12.5,
      }}
    >
      {cells.name}
      <div style={{ minWidth: 0 }}>{cells.handle}</div>
      <div style={{ textAlign: 'right' }}>{cells.audience}</div>
      <div style={{ color: 'var(--nb-ink-2)' }}>{cells.cadence}</div>
      {cells.verify}
    </div>
  );
}
